<template>
  <div class="switch-wrap" :class="{ active: value }" @click="toggleValue">
    <div class="circle"></div>
  </div>
</template>

<script>
export default {
  name: "DSwitch",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    toggleValue() {
      this.$emit("input", !this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.switch-wrap {
  width: 32px;
  height: 16px;
  border-radius: 8px;
  position: relative;
  background: #374151;
  cursor: pointer;
  .circle {
    width: 14px;
    height: 14px;
    border-radius: 8px;
    background: white;
    position: absolute;
    top: 1px;
    left: 2px;
    transition: all 0.3s;
  }
  &.active {
    background: #4689f3;
    .circle {
      left: 20px;
    }
  }
}
</style>
